import { Injectable } from '@angular/core';

import { medidasStorage } from "./data.service";
import { MaterialService } from "../../materiais/material/shared/material.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { materialStorageName } from "../../materiais/material/shared/data.service";

@Injectable()
export class MedidaService {

  constructor(
    private _materialService: MaterialService,
    private _autocompleteService: AutoCompleteService
  ){}

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(medidasStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(medidasStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(medidasStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    var otherFormObject: any;
    if(Response) {
      if (otherForm === materialStorageName) {
        otherFormObject = this._materialService.getSessionStorage();
        otherFormObject.medida = Response;
        this._materialService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(medidasStorage);

    if (otherForm === materialStorageName) {
      otherFormObject = this._materialService.getSessionStorage();
      if (otherFormObject.id) {
        this._materialService.goToEdit(otherFormObject.id);
      } else {
        this._materialService.goToAdd();
      }
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/medidas/shared/medida.service.ts
 **/